import React,{useEffect,useState } from 'react';
import { ADD_VEHICLE_List } from '../constant'; 
import { Circles } from 'react-loader-spinner';
import axios from 'axios';
import VehicleTable from '../components/tables/VehicleTable';
import {currentDateFormat} from "../utils";
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../redux/loaderAction';
//import Loader from '../components/loader/Loader';

const DriverList = () =>{ 
    const [vehicleDetails,setVehicleDetails] = useState([]);
    const [questionList,setQuestionList] = useState([]);
    const dispatch = useDispatch();
    //const loading = useSelector((state) => state.loader.loading);
    const [currentDate,setCurrentDate] = useState(new Date());
    useEffect(()=>{
      dispatch(setLoading(true));
      //return false;
        axios.get(ADD_VEHICLE_List)
        .then(response => {
          dispatch(setLoading(false));
           console.log("response.data",response.data);
           setVehicleDetails(response.data.data.result);
           setQuestionList(response.data.data.questionsList);
         })
        .catch(error => {
           console.error(error);
         });

    },[]);

    
    return(
        <><section>
          <div className='d-flex justify-content-between form-container'>
            <div>
              <h2 className="fs-5 font-weight-600">Vehicle List </h2>
            </div>
          <div>
            <span >{currentDateFormat(currentDate)}</span>
          </div>
        </div>
        </section>
        <section>
            <div>
                <VehicleTable 
                tableData={vehicleDetails}
                setTabelData={setVehicleDetails}
                questionList={questionList}
                 />              
            </div>
         </section>
         {/* {loading && <Loader />} */}
         </>
    );
 }
export default DriverList;